import React, { useState, useRef, useEffect, useCallback } from "react";
import ListPageHeader from "../../utilities/ListPageHeader";
import FusePageCarded from "@fuse/core/FusePageCarded/FusePageCarded";
import AgGridTable from "../../utilities/AgGridTable";
import Cards from "./Card";
import data from "./data";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import { Button, Card, IconButton, Tooltip, Typography } from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { useTheme } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .new, & .assigned, & .placed, & .ab_received, & .invoiced, & .inprogress": {
      borderRadius: "20px",
      fontSize: "11px",
      textAlign: "center",
      height: '26px',
      lineHeight: '26px',
      padding: '0px 10px',
      marginTop: '6px',
      color: theme.palette.common.white,
    },
    "& .new": {
      backgroundColor: theme.palette.info.main,
    },
    "& .assigned": {
      backgroundColor: theme.palette.warning.main,
    },
    "& .placed": {
      backgroundColor: theme.palette.grey[500],
    },
    "& .ab_received": {
      backgroundColor: theme.palette.success.main,
    },
    "& .invoiced": {
      backgroundColor: theme.palette.success.main,
    },
    "& .inprogress": {
      backgroundColor: theme.palette.success.main,
    },
  },
}));

const CreateNewType = (props) => {
  return (
    <>
      <Tooltip title={"Create a New Type"}>
        <IconButton>
          <FuseSvgIcon size={16} color="action">
            heroicons-solid:color-swatch
          </FuseSvgIcon>
        </IconButton>
      </Tooltip>
      <Tooltip title={"Create Part Order"}>
        <IconButton>
          <FuseSvgIcon size={24} color="action">
            heroicons-solid:plus
          </FuseSvgIcon>
        </IconButton>
      </Tooltip>
      {/* <Button size="small" variant="contained" color="primary" sx={{ background: '#826210', color: '#fff', fontSize: '11px'}}>Create a New Type</Button> */}
    </>
  );
};

const Order = (props) => {
  const classes = useStyles(props);
  const navigate = useNavigate();
  const theme = useTheme();
  const [rowData, setRowData] = useState(data);
  const gridRef = useRef();
  const [showPaginationDropdown, setShowPaginationDropdown] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [columnDefs, setColumnDefs] = useState([
    {
      cellRenderer: (data) => <CreateNewType />,
      minWidth: 100,
    },
    {
      headerName: 'Order Characteristics',
      children: [
        { headerName: 'AB Number', field: 'abNumber', },
        { headerName: 'Commission Name', field: 'commissionName', },
        { headerName: 'Unique id.', field: 'uniqueId', },
        { headerName: 'Product', field: 'product', },
        { headerName: 'Vendor Account No', field: 'vendorAccount', },
        { headerName: 'Category', field: 'product', columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Order Type(SO/AO)', field: 'orderType', columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Territory', field: 'territory', columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Customer', field: 'customer', columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Region', field: 'region', columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Showroom', field: 'showroom', columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Kitchen', field: 'kitchen', columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Furniture', field: 'furniture', columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Spa', field: 'spa', columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Living', field: 'living', columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'List Price Wg1', field: 'listPriceWg1', columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'List price WG2', field: 'listPriceWG2', columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Total List Price', field: 'totalListPrice', columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Range1', field: 'range1', columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Color1', field: 'color1', columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Carcass1', field: 'carcass1', columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Handle1', field: 'handle1', columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
      ],
    },
    {
      headerName: 'Logistics',
      children: [
        { headerName: 'Volume', field: "volume", },
        { headerName: 'Weight', field: "weight", },
        { headerName: 'No of Packs', field: "noOfPacks", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Internal Cont. No', field: "internalContNo", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Actual cont. No', field: "actualContNo", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'PORT', field: "port", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Mode of Shipping', field: "modeOfShipping", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Tour No', field: "tourNo", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
      ]
    },
    {
      headerName: 'Commercial (Rcvbl)',
      children: [
        { headerName: 'Receivable', field: "receivable", },
        { headerName: 'STD DISC WG1', field: "STDDISCWG1", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'SPL DISC WG1 (*Authorized access)', field: "SPLDISCWG1", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'SDR WG1(* Through Approval)', field: "SDRWG1", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Promotional Discount WG1', field: "promotionalDiscountWG1", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Cumulative Discount WG1', field: "cumulativeDiscountWG1", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'STD DISC WG2', field: "STDDISCWG2", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'SPL DISC WG2 (*Authorized access)', field: "SPLDISCWG2", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'SDR WG2(* Through Approval)', field: "SDRWG2", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Promotional Discount WG2', field: "promotionalDiscountWG2", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Cumulative Discount WG2', field: "cumulativeDiscountWG2", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Margin', field: "orderNo", columnGroupShow: 'margin', filter: 'agNumberColumnFilter', },
        { headerName: 'Gesture to Customer', field: "gestureToCustomer", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
      ]
    },
    {
      headerName: 'Commercial (Payable)',
      children: [
        { headerName: 'Payable', field: "payable", },
        { headerName: 'STD DISC WG1', field: "STDDISCWG1Payable", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'SPL DISC WG1 (*Authorized access)', field: "SPLDISCWG1Payable", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'SDR WG1(* Through Approval)', field: "SDRWG1Payable", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Promotional Discount WG1', field: "promotionalDiscountWG1Payable", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Cumulative Discount WG1', field: "cumulativeDiscountWG1Payable", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'STD DISC WG2', field: "STDDISCWG2Payable", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'SPL DISC WG2 (*Authorized access)', field: "SPLDISCWG2Payable", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'SDR WG2(* Through Approval)', field: "SDRWG2PayablePayable", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Promotional Discount WG2', field: "promotionalDiscountWG2Payable", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Cumulative Discount WG2', field: "cumulativeDiscountWG2Payable", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Gesture to Customer', field: "gestureToCustomerPayable", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
      ]
    },
    {
      headerName: 'History',
      children: [
        { headerName: 'Order Received Date', field: "orderReceivedDate", },
        { headerName: 'Order Placed Date', field: "orderPlacedDate", },
        { headerName: 'AB Received Date', field: "ABReceivedDate", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Confirmed Date', field: "confirmedDate", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Loading Plan Date', field: "loadingPlanDate", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Loading Plan Week', field: "loadingPlanWeek", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Cut off Date', field: "cutoffDate", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Release date', field: "releaseDate", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Actual Loading Date', field: "actualLoadingDate", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Actual Loading week', field: "actualLoadingWeek", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
      ]
    },
    {
      headerName: 'Approvals',
      children: [
        { headerName: 'SDR Approved', field: "SDRApproved", },
        { headerName: 'SDP Approved', field: "SDPApproved", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'PSD Approved', field: "PSDApproved", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Approval for Booking', field: "approvalForBooking", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Approval to Release', field: "approvalToRelease", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
        { headerName: 'Skip Promotion', field: "skipPromotion", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
      ]
    },
    {
      headerName: 'AO Info',
      children: [
        { headerName: 'Reason', field: "reason", },
        { headerName: 'Reason Note', field: "reasonNote", columnGroupShow: 'open', filter: 'agNumberColumnFilter', },
      ]
    },
    // { field: "orderNo", headerName: "Order .No", enableRowGroup: true },
    // { field: "commissionName", headerName: "Commission Name", enableRowGroup: true },
    // { field: "product", headerName: "Product", enableRowGroup: true },
    // { field: "category", headerName: "Category", enableRowGroup: true },
    // { field: "assigned", enableRowGroup: true, headerName: "Assigned To" },
    // { field: "created", enableRowGroup: true, headerName: "Created On" },
    // { field: "processed", enableRowGroup: true, headerName: "Processed On", 
    //     cellClass: (params) => {
    //         if (params.value === "NEW") {
    //         return "new";
    //         } else if (params.value === "ASSIGNED") {
    //         return "assigned";
    //         } else if (params.value === "PLACED") {
    //         return "placed";
    //         } else if (params.value === "AB_RECEIVED") {
    //         return "ab_received";
    //         } else if (params.value === "INVOICED") {
    //         return "invoiced";
    //         } else if (params.value === "IN_PROGRESS") {
    //         return "inprogress";
    //         }
    //         return null;
    //   }, 
    // },
  ]);
  const onGridReady = useCallback((params) => {
    //loadRates();
  }, []);
  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };

  const onRowDoubleClicked = (params) => {
    var filename = selectedRows[0]?.id;
    navigate("/order/view-order/" + filename);
  };

  const handleCreateOrder = () => {
    navigate("/order/create-order/");
  }

  return (
    <>
      <FusePageCarded
        classes={{
          content: "flex",
          header: "min-h-72 h-72 sm:h-136 sm:min-h-136",
        }}
        header={<ListPageHeader componentName="Order" pageName="Order" showPaginationDropdown={showPaginationDropdown} />}
        content={
          <>
            <div className="flex flex-col sm:flex sm:flex-row px-12 mb-8 mt-8">
              <div className="w-full sm:w-1/4 p-4">
                <Card onClick={handleCreateOrder} className="relative flex flex-col flex-auto justify-center rounded-2xl shadow py-10 px-16" sx={{ backgroundColor: theme.palette.primary.main, cursor: 'pointer', minHeight: '64px' }}>
                  <div className="flex items-center">
                    <FuseSvgIcon size={24} color="action">
                      heroicons-outline:plus-circle
                    </FuseSvgIcon>
                    <div className="ml-10">
                      <Typography sx={{ fontSize: '16px' }}>Create Order</Typography>
                    </div>
                  </div>
                </Card>
              </div>
              <Cards />
            </div>
            <div
              className={clsx(
                classes.root,
                "px-12 h-full",
                theme.palette.mode === "dark"
                  ? "ag-theme-alpine-dark"
                  : "ag-theme-alpine"
              )}
            >
              <AgGridTable
                rowData={rowData}
                columnDefs={columnDefs}
                onGridReady={onGridReady}
                gridRef={gridRef}
                onRowDoubleClicked={onRowDoubleClicked}
                onSelectionChanged={onSelectionChanged}
                hideCheckbox={true}
                editable={false}
                rowHeight={35}
                headerHeight={36}
              />
            </div>
          </>
        }
        innerScroll
      />
    </>
  );
};

export default Order;
